import "./Article.css";

function ArticleCardLoading() {
  return (
    <div className="article-skeleton">
      <div className="shimmer article-skeleton__image" />
      <div className="article-skeleton__body">
        <div className="shimmer article-skeleton__line article-skeleton__line--wide" />
        <div className="shimmer article-skeleton__line article-skeleton__line--mid" />
        <div className="shimmer article-skeleton__line article-skeleton__line--sm" />
      </div>
    </div>
  );
}

export default ArticleCardLoading;
